/**
 * Created by lenovo on 2017/2/14.
 */
import React, {
    Component,
    PropTypes
}from 'react';
import {Link} from 'react-router'
import {ellaUrl} from '../../path.config'
import ellaService from 'SERVICES/purifier/ella/ellaService'
import Tip from 'COMPONENT/tip'
import ErrorSpan from 'COMPONENT/errorSpan'
import FormInput from 'CONFIG/component/form/formInput'
import FormInputSimple from 'CONFIG/component/form/formInputSimple'
import {alertTip,resultTip,errorShow,errToSuc} from 'UTIL/common'
import {language} from 'UTIL/common'
import BoxHeaderCreate from 'CONFIG/component/boxHeaderCreate'
import {getNowFormatDate} from 'CONFIG/function'
import FormSelect from "CONFIG/component/form/formSelect";
function timestamp(endTime){
    var date=new Date();
    date.setFullYear(endTime.substring(0,4));
    date.setMonth(endTime.substring(5,7)-1);
    date.setDate(endTime.substring(8,10));
    date.setHours(endTime.substring(11,13));
    date.setMinutes(endTime.substring(14,16));
    date.setSeconds(endTime.substring(17,19));
    return Date.parse(date)/1000;
}
export default class APPCreate extends Component {
    constructor(props) {
        super(props);
        this.submit = this.submit.bind(this);
        this.state = {
            url: ellaUrl,
            operationList:{"android":'android',"ios":"ios","android-tw":"androidtaiwan"},
        }
    }
    componentDidMount(){
        var scrollFunc=function(e){
            e=e || window.event;
            if(e.wheelDelta){//IE/Opera/Chrome
                $("#laydate_box").hide()
            }else if(e.detail){//Firefox
                $("#laydate_box").hide()
            }
        }
        /*注册事件*/
        if(document.addEventListener){
            document.addEventListener('DOMMouseScroll',scrollFunc,false);
        }
        window.onmousewheel=document.onmousewheel=scrollFunc;
    }
    submit(event) {
        event.preventDefault();
        errToSuc();
        const versionCode = $.trim($('#versionCode').val());
        const versionName = $.trim($('#versionName').val());
        const operation = $.trim($("#operation").val());
        const url = $.trim($("#url").val());
        const date = $.trim($("#date").val());
        var errorMessage = '';
        if(versionCode == ''){
            errorShow('versionCode');
        }
        if(versionName == ''){
            errorShow('versionName');
        }
        if(operation == ''){
            errorShow('operation');
        }
        if(date == ''){
            errorShow('date');
        }
        if(url == ''){
            errorShow('url');
        }

        if($("[name='error']").length == 0){
            const json = {
                "versionCode": versionCode,
                "versionName": versionName,
                "showDate":date,
                "operation" : operation ,
                "url" : url
            }
            var data = JSON.stringify(json);
            ellaService.appversionDoAddOrUpdate({data}).then(body=>{
                resultTip(body,'/ella/app')
            })
        }

    }
    change(id){
        if($.trim($("#"+id).val())==''){
            errorShow(id);
        }else{
            var this_id = 'error_'+id;
            $("#"+this_id).html('');
            $("#"+this_id).attr("name","success");
            $("#"+this_id).parent().attr("class","");
            $("#"+this_id).siblings().attr("class","");
        }
    }
    dateClick(){
        laydate({
            elem: '#date',
            format: 'YYYY-MM-DD hh:mm:ss',
            istime: true,
        });
        $("#laydate_box").show();
    }
    render() {
        return (
            <div>
                <section className="content-header">
                    <h1> {language()['APPManagement']} <small>{language()['APPVersionsAdd']}</small> </h1>
                </section>
                <section className="content">
                    <div className="box box-primary color-palette-box">
                        <div className="box-header with-border">
                            <i className="fa fa-plus-circle"></i>
                            <h3 className="box-title">{language()['APPVersionsAdd']}</h3>
                        </div>
                        <div className="box-body">
                            <Tip ids=""/>
                            <div>
                                <form className="form-horizontal" role="form" id="form">
                                    <FormSelect name="systemType" id="operation" data={this.state.operationList}/>
                                    <FormInput name = "systemName" id="versionName"/>
                                    <FormInput name = "versionNumber" id="versionCode"integer = "true"/>
                                    <div className="row form-group">
                                        <label  className="multi-label control-label col-xs-2">{language()['versionTime']}</label>
                                        <div className="col-xs-3">
                                            <input type="text" className="form-control"  onFocus={this.dateClick.bind(this)}
                                                   onClick={this.dateClick.bind(this)}
                                                   onChange={this.change.bind(this,'date')}
                                                   placeholder={language()['versionTime']}  id="date" name="date" />
                                        </div>
                                        <ErrorSpan id="date"/>
                                    </div>
                                    <div className="row form-group">
                                        <label  className="multi-label control-label col-xs-2">{language()['download']}</label>
                                        <div className="col-xs-3">
                                            <textarea type="text" className="form-control"  id="url" onChange={this.change.bind(this,'url')}
                                                      placeholder={language()['download']}  />
                                        </div>
                                        <ErrorSpan id="url"/>
                                    </div>

                                </form>
                                <div className="row form-group">
                                    <div className="col-xs-2 text-center">
                                    </div>
                                    <div className="col-xs-1 text-center">
                                        <Link to={"/ella/app"} className="btn btn-default">{language()['return']}</Link>
                                    </div>
                                    <div className="col-xs-1 text-center" >
                                        <button id="btnSubmit" className="btn btn-success" onClick={this.submit.bind(this)}>{language()['submit']}</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./modules/ella/app/appCreate.js